<template>
  <div>
    <div class="mb-2">
      <ErrorAlert></ErrorAlert>
      <div>
        <div class="row">
          <div class="col-12">
            <form autocomplete="on" @submit.prevent="saveSettings">
              <div v-for="(setting)  in settings" :key="setting.key"
                   class="form-group row mb-3">
                <label class="text-uppercase col-12 col-md-5 col-form-label" :for="setting.key">{{ snakeToWords(setting.key) }}:</label>
                <div class="col-12 col-md-7">
                  <input
                      :id="setting.key"
                      type="number"
                      step="0.0001"
                      class="form-control"
                      :name="setting.key"
                      v-model="setting[`value_${setting.type}`]"
                  />
                </div>
              </div>
              <div class="text-right mt-4">
                <button class="btn btn-primary">Save</button>
              </div>
            </form>
          </div>
          <!-- end col -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ErrorAlert from "@/components/errorAlert";
import {snakeToWords, Toast} from "@/state/helpers";

export default {
  components: {ErrorAlert},
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const response = await axios.get('/admin/setting');
      this.settings = response.data;
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  data() {
    return {
      settings: []
    }
  },
  methods: {
    snakeToWords: snakeToWords,
    async saveSettings() {
      const data = {
        settings: this.settings.map(function (setting) {
          setting.value = setting[`value_${setting.type}`]
          return setting;
        }),
      }

      this.$store.commit('loader/START_LOADING');

      try {
        await axios.put('/admin/setting/bulk-update', data);
        this.$emit('saved', this.settings)
        Toast.fire({
          title: `Platform settings updated.`,
          icon: "success",
        })
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    }
  }
}
</script>
